/**
 * main.ts —— 应用入口
 *
 * 启动顺序有讲究：
 *   1. 先注入全局样式（变量 + 主题 + reset），保证组件首次渲染就有样式
 *   2. 注册组件
 *   3. 挂载模态框到 body（它是全局覆盖层，不属于任何页面）
 */

import { injectGlobalStyles } from '@/styles/sheet-cache';

// 1. 全局样式必须先于任何组件渲染
injectGlobalStyles();

// 2. 注册组件（import 副作用即注册）
import '@/shell/lx-shell';
import '@/components/lx-title-bar';
import '@/components/lx-tab-bar';
import '@/components/lx-empty-state';
import '@/components/lx-session-list';
import '@/components/lx-contact-list';
import '@/components/lx-contact-editor';
import '@/components/lx-chat-view';
import '@/components/lx-page-home';
import '@/components/lx-page-contacts';
import '@/components/lx-page-settings';
import '@/components/lx-ai-input';
import '@/components/lx-ai-modal';
import '@/components/lx-digest-view';
import '@/components/lx-camera-view';
import '@/components/lx-debug-view';
import '@/components/lx-voice-view';
import '@/components/lx-toast';

// 3. 全局层挂在 body 上：模态框 + 轻提示
const modal = document.createElement('lx-ai-modal');
document.body.appendChild(modal);
const toast = document.createElement('lx-toast');
document.body.appendChild(toast);

// 4. 挂载前先做一次主题初始化，避免首帧闪白
import { settingsRepo, applyTheme, applyFontScale } from '@/settings/settings';
const bootSettings = settingsRepo.getApp();
applyTheme(bootSettings.theme);
applyFontScale(bootSettings.fontScale);

// 5. 开发环境打印一份能力自检，方便确认组件都注册上了
if (import.meta.env.DEV) {
  const expected = [
    'lx-shell',
    'lx-title-bar',
    'lx-tab-bar',
    'lx-empty-state',
    'lx-session-list',
    'lx-contact-list',
    'lx-contact-editor',
    'lx-chat-view',
    'lx-page-home',
    'lx-page-contacts',
    'lx-page-settings',
    'lx-ai-input',
    'lx-ai-modal',
    'lx-digest-view',
    'lx-camera-view',
    'lx-debug-view',
    'lx-voice-view',
    'lx-toast',
  ];
  const missing = expected.filter((tag) => !customElements.get(tag));
  if (missing.length) {
    console.error('[灵讯] 以下组件未注册：', missing);
  } else {
    console.info(`[灵讯] ${expected.length} 个组件注册完成`);
  }
}
